
import { FormsFeatureContext } from '@ngt/forms';
import { useCallback, useContext } from 'react';
import { StagePlanPostSave, StagePlanPostSaveResponse } from '../../api/dtos';

export const usePostStagePlanSave = () => {
    const formsFeature = useContext(FormsFeatureContext);


    // @ts-ignore
    const save = useCallback(async (stagePlan?: StagePlan) => {
        if(!stagePlan) return false;
        const response: StagePlanPostSaveResponse = await formsFeature.serviceStackClient.post(new StagePlanPostSave({ stagePlan: stagePlan}))

        return response.responseStatus;
    }, [formsFeature.serviceStackClient]);

    return save;
};

export default usePostStagePlanSave;